// extracted by mini-css-extract-plugin
export var cardSelected = "_fu-2";
export var image = "_fu-1";
export var table = "_fu-0";